const $ = window.$
import React from 'react'
import {connect} from 'react-redux'
import {MetalColor, Finish, NotSure, PreviousLink, NextSteps, Gemstones, nextFrame} from './shared'
import {CheckMarkCard, Select} from 'js/studios/shared/flows'

const PENDANT_METAL_COLOR_CARDS = [
  {
    name: "silver_color",
    img: "//images.custommade.com/DPYfel0tvVoLSz2bCH-MhxFe3f4=/custommade-attachments/ffec4d5ff63a7eb__2_metal_color_28de9334887a653_624998_1.jpg",
    label: "White Gold, Silver, Platinum"
  },
  {
    name: "yellow",
    img: "//images.custommade.com/GBjIjfy_SeYMgl43k4mBqcw4TZY=/custommade-attachments/e057e17afa102bf__2_metal_color_2410cd3e8f7ccb8_692274_2.jpg",
    label: "Yellow Gold"
  },
  {
    name: "rose",
    img: "//images.custommade.com/G2oopaO2z2wdsx8KWuficLWe62Q=/custommade-attachments/cbe4f4babdf2271__2_metal_color_c08bbeb882d0f0a_440858_1_1.jpg",
    label: "Rose Gold"
  },
  {
    name: "mixed_metals",
    img: "//images.custommade.com/sDNxr437OOaxf3nwoudapCWkrgo=/custommade-attachments/0ec20e1386214f4__2_metal_color_5c6fb3117bce0ef_624655_1_1.jpg",
    label: "Mixed Metals"
  }
]

export class PendantMetalColor extends React.Component {

  render(){
    return (
      <MetalColor cards={PENDANT_METAL_COLOR_CARDS} subheader="Do you know what color you’d like your neckace to be?" {...this.props} />
    )
  }
}


const PENDANT_FINISH_CARDS = [
  {
    name: "polished",
    img: "//images.custommade.com/pKUwMw8BkgR-1QYeQzzH39Q_C7A=/custommade-attachments/7847907f919aa90__3_finish_84ad6bc07cd8679_509684_1.jpg",
    label: "Polished"
  },
  {
    name: "brushed",
    img: "//images.custommade.com/pwZngHhK_16IuXXkQGw4ou5HVmU=/custommade-attachments/d86f09608eabf4e_pendant_brushed.jpg",
    label: "Brushed"
  },
  {
    name: "oxidized",
    img: "//images.custommade.com/dNVYZvtI650nPnVXL7BDDtTv3kA=/custommade-attachments/a58222a65f58f9a__3_finish_e7d075438182acb_458560_1.jpg",
    label: "Oxidized"
  },
  {
    name: "enamel",
    img: "//images.custommade.com/pwkPv_vLx_lgZD-hUAZsCDsuHiU=/custommade-attachments/bb47d6f3d85d387__3_finish_5136e5c07b2cb6b_665375_1.jpg",
    label: "Enamel"
  },
]


export class PendantFinish extends React.Component {

  render(){
    return (
      <Finish cards={PENDANT_FINISH_CARDS} {...this.props} />
    )
  }
}


const PENDANT_GEMSTONES_CARDS = [
  {
    name: "include_gemstones",
    img: "//images.custommade.com/dfjAw8VGma2PnoQ1Hv-jTuEw5Nc=/custommade-attachments/80343128a2cc880_pendant_gemstones.jpg",
    label: "Yes, I am interested in gemstone(s)"
  },
  {
    name: "all_metal_pendant",
    img: "//images.custommade.com/zGy36UIEsufju8hphKjbJujeZNg=/custommade-attachments/3676122ae1a918c__4_gemstones_973b2db34982fc3_644848_2_2.jpg",
    label: "No, I want an all-metal pendant"
  }
]

export class PendantGemstones extends React.Component {

  render(){
    return (
      <Gemstones cards={PENDANT_GEMSTONES_CARDS} subheader="Are you considering any gemstones for your neckace?" {...this.props} />
    )
  }
}

const SOLID_OR_CUTOUT_CARDS = [
  {
    name: "solid_raised",
    imgs: [
      "//images.custommade.com/ruIBUI3CP8lvHilvwoNRk0en1NY=/custommade-attachments/58fbed268d7fed3__5_solid_or_cutout_solid_raised_f5d3fdc6fdaa37b_708427_1.jpg",
      "//images.custommade.com/r-XSIKvJvuY9rYFbNRuFLDd3vas=/custommade-attachments/a5a01da3409032b__5_solid_or_cutout_solid_raised_e03185100d94d7f_530210_9.jpg",
      "//images.custommade.com/JFi--B_DgYCaG8HOLYUqEDWCIm8=/custommade-attachments/0d035b657038397__5_solid_or_cutout_solid_raised_7c436f4ce8dd7cf_611523_3.jpg",
    ],
    label: "Solid (Raised)"
  },
  {
    name: "solid_recessed",
    imgs: [
      "//images.custommade.com/5KCyZDrw3mBtLFzqQhAzWbn9IvE=/custommade-attachments/2d266bdc9039b8d__5_solid_or_cutout_solid_recessed_08c28804e232a20_648437_5_2.jpg",
      "//images.custommade.com/IDS8emRtjbnzrmh1VSTHE22_QlI=/custommade-attachments/b723514b41433fb__5_solid_or_cutout_solid_recessed_9da95cb77265a35_707979_2.jpg",
      "//images.custommade.com/PSpNUbUyzLStGAoY0vyMdScNJns=/custommade-attachments/98125a46e5db6ee__5_solid_or_cutout_solid_recessed_d3bc734f88b8076_698170_3.jpg",
    ],
    label: "Solid (Recessed)"
  },
  {
    name: "cutout",
    imgs: [
      "//images.custommade.com/o4lHftyWlZZmqCLeER8t3JjhR8U=/custommade-attachments/b184ed95539cab5__5_solid_or_cutout_cutout_1f810b7575924a1_745621_1.jpg",
      "//images.custommade.com/Da56EQv9YjXjPWMCvdg_NDEG0Zc=/custommade-attachments/64057d0cec84a2b__5_solid_or_cutout_cutout_dc75e218c7093d3_459325_2.jpg",
      "//images.custommade.com/wythL6B6CdfeUYNM3ElMnaf4UbY=/custommade-attachments/5895ffc08e7b2f4__5_solid_or_cutout_cutout_da6af0e14a86eb6_687279_3.jpg",
    ],
    label: "Cutout"
  }
]


@connect(state => ({
  solidOrCutout: state.projectCreationData.solidOrCutout,
  solidOrCutoutSkip: state.projectCreationData.solidOrCutoutSkip
}))
export class SolidOrCutout extends React.Component {

  isChecked(name){
    return this.props.solidOrCutout === name
  }

  toggleChecked(name, _e){
    if (!this.props.finishSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'solidOrCutout',
        value: name
      })
    }
  }

  render(){
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Solid or Cutout</h2>
            <p className="subheader-body">We can create your pendant as a solid shape with your design raised from the surface or recessed from the surface. Or, we can create a cutout in the shape of your design. Which of these options do you like best?</p>
            <div className="cards-wrapper">
              {SOLID_OR_CUTOUT_CARDS.map(card => (
                <CheckMarkCard
                  key={card.name}
                  className="card-block"
                  name={card.name}
                  label={card.label}
                  imgs={card.imgs}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.solidOrCutoutSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  />
              ))}
            </div>
            <NotSure field="solidOrCutoutSkip" fieldsToWipe={['solidOrCutout']} resetValue={[]} checked={this.props.solidOrCutoutSkip}>I'm not sure yet</NotSure>
          </div>
        </div>
        {((this.props.solidOrCutout && this.props.solidOrCutout.length > 0) || this.props.solidOrCutoutSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


const PENDANT_SHAPE_CARDS = [
  {
    name: "circle",
    img: "//images.custommade.com/RRtOUtzfYvwcFGf7EAr_eiaAObs=/custommade-attachments/60d6a2d0684a56a__6_pendant_shape_147a2687a0a1110_568300_2.jpg",
    label: "Circle"
  },
  {
    name: "heart",
    img: "//images.custommade.com/qYTQnKvkx1CWTqRMuWZoVVTHc1Y=/custommade-attachments/5ce4354001b5d12__6_pendant_shape_ad67ae83aa68d20_520989_5.jpg",
    label: "Heart"
  },
  {
    name: "square",
    img: "//images.custommade.com/0Zuam2_cet6gAmGIPdrD6knf_vo=/custommade-attachments/a23dc9d7ed2a37b__6_pendant_shape_ee75f8fdf41b10d_547176_4_2.jpg",
    label: "Square"
  },
  {
    name: "rectangle",
    img: "//images.custommade.com/U0X4FGOSSRLTAOjZz0bUurerzBk=/custommade-attachments/add0b8d75edbd4b__6_pendant_shape_6432cd7f530325f_571346_1.jpg",
    label: "Rectangle",
    smallText: true
  },
  {
    name: "shield",
    img: "//images.custommade.com/DJqAhUMxGpzQVaSeWHfrSJVobs0=/custommade-attachments/2e49a4da0421da9__6_pendant_shape_a4d558245f5829a_433179_1.jpg",
    label: "Shield"
  },
  {
    name: "cross",
    img: "//images.custommade.com/yQq9vusR-F-L1fblOcQxPt6xEeA=/custommade-attachments/7cc16f8f1726cb9__6_pendant_shape_b89a3a2cd559d50_517994_1.jpg",
    label: "Cross"
  },
  {
    name: "oval",
    img: "//images.custommade.com/dAfMey5A7EqpayxtklBK8yz2MX4=/custommade-attachments/0364e2d890382ce__6_pendant_shape_07fa1cb371fdb08_471068_3.jpg",
    label: "Oval"
  },
  {
    name: "letters",
    img: "//images.custommade.com/rvMk46Ja8Jz7xLVQMJDRxWAyXiM=/custommade-attachments/f7a5e1e1be510fb__6_pendant_shape_6ed3c5faca2a981_419215.jpg",
    label: "Letters"
  },
  {
    name: "puzzle",
    img: "//images.custommade.com/hIyidYhrzZ0xJu80zRXDZwlA-xk=/custommade-attachments/568c5d930fffcd8__6_pendant_shape_8cbf4bc75d71f5a_521942_a_2.jpg",
    label: "Puzzle"
  },
  {
    name: "custom",
    img: "//images.custommade.com/JAx7NZTxXm1Ey5skivk3sTrnYLA=/custommade-attachments/e1d28ebfb1e781f__6_pendant_shape_d44e114727a2d62_579715_2.jpg",
    label: "Custom"
  },
]

@connect(state => ({
  pendantShape: state.projectCreationData.pendantShape,
  pendantShapeSkip: state.projectCreationData.pendantShapeSkip
}))
export class PendantShape extends React.Component {

  isChecked(name){
    return this.props.pendantShape === name
  }

  toggleChecked(name, _e){
    if (!this.props.finishSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'pendantShape',
        value: name
      })
    }
  }

  render(){
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Pendant Shape</h2>
            <p className="subheader-body">Circular pendants are our most popular choice, but there’s no wrong answer when it comes to shape! Since our necklaces are fully custom, you aren't limited to the examples - we can create any shape you like.</p>
            <div className="cards-wrapper">
              {PENDANT_SHAPE_CARDS.map(card => (
                <CheckMarkCard
                  key={card.name}
                  className={"card-small " + (card.smallText ? "card-small-text" : "")}
                  name={card.name}
                  imgUrl={card.img}
                  label={card.label}
                  checked={this.isChecked(card.name)}
                  disabled={this.props.pendantShapeSkip}
                  toggleChecked={this.toggleChecked.bind(this, card.name)}
                  />
              ))}
            </div>
            <NotSure field="pendantShapeSkip" fieldsToWipe={['pendantShape']} resetValue={[]} checked={this.props.pendantShapeSkip}>I'm not sure yet</NotSure>
          </div>
        </div>
        {((this.props.pendantShape && this.props.pendantShape.length > 0) || this.props.pendantShapeSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}



@connect(state => ({
  pendantSize: state.projectCreationData.pendantSize,
  pendantSizeSkip: state.projectCreationData.pendantSizeSkip,
}))
export class PendantSize extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      gender: "male"
    }
  }

  updateField(field, e){
    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: field,
      value: $(e.target).val()
    })
  }

  render(){
    return (
      <form className={"frame-wrapper fade-in pendant-size" + (this.props.pendantSize && this.props.pendantSize.length > 0 ? " size-" + this.props.pendantSize.replace('.', '_').replace("in", "") : " size-0_5")} onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Pendant Size</h2>
            <p className="subheader-body">How large are you envisioning this pendant? Popular smaller sizes are 0.75"
 (like a US penny) and 1" (like a US quarter).  If you're looking for something more substantial -- 1.25" or larger is a good bet.
            </p>
            <div className="ring-size-img-wrapper">
              <img className="background" src="//images.custommade.com/d2GgKlQbWsfPYks7DU_KpHqxDK8=/custommade-attachments/99aedd0cf75b965__7_pendant_size_gray_silhouette_01.png" />
              <div className="size-overlay-wrapper">
                <img className="size-overlay" src="//images.custommade.com/ERzvwy9zTqJimvnKJzOKHWjF5WU=/custommade-attachments/3e4b684967ae665__7_pendant_size_20027faf274151e_2.png" />
              </div>
            </div>
            <div className="field">
              <Select onChange={this.updateField.bind(this, 'pendantSize')} value={this.props.pendantSize} disabled={this.props.pendantSizeSkip} label="Choose pendant size">
                <option value="0.5 in">Petite (0.5")</option>
                <option value="0.75 in">Small (0.75")</option>
                <option value="1 in">Standard (1")</option>
                <option value="1.25 in">Large (1.25")</option>
                <option value="1.5 in">Extra Large (1.5")</option>
              </Select>
            </div>
            <NotSure field="pendantSizeSkip" fieldsToWipe={['pendantSize']} resetValue={[]} checked={this.props.pendantSizeSkip}>I'm not sure yet</NotSure>
          </div>
        </div>
        {((this.props.pendantSize && this.props.pendantSize.length > 0) || this.props.pendantSizeSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


const PENDANT_CHAIN_LENGTHS = {
  "14": "//images.custommade.com/B1ySzkjjuKLkFx0-KfqUDjpojSo=/custommade-attachments/1b81a1476c41105__oval_copy.png",
  "16": "//images.custommade.com/WqU7dV71WKQBofo9qwVu5dhbVzM=/custommade-attachments/5e3f01db4c89cf3__oval.png",
  "18": "//images.custommade.com/bu6unIMlbamLfLj6QBQWchPMktg=/custommade-attachments/a24ccc705b24e45__oval_copy_2.png",
  "20": "//images.custommade.com/eVJ6VourGMgVKs2zDC7VpK0gi64=/custommade-attachments/fe865efa77695b1__oval_copy_3.png",
  "22": "//images.custommade.com/U9GLZtwrp9O6aN5JxRN06mKtkas=/custommade-attachments/ca00e0f3d7cea48__oval_copy_4.png",
  "24": "//images.custommade.com/SVOyqx9-iKMTffAktNQuMy2P6OQ=/custommade-attachments/dc0ed4ecf933a9d__oval_copy_5.png",
  "30": "//images.custommade.com/5DpY_YpTaYfPa1eTSRochFhD-xU=/custommade-attachments/b2e44c3f451c9d9__oval_copy_6.png",
  "36": "//images.custommade.com/9uMWLJ3P7Z3IYvswhKmEeFCrqUg=/custommade-attachments/9940d2dc71f7d64__oval_copy_7.png",
}


@connect(state => ({
  chainLength: state.projectCreationData.chainLength,
  chainLengthSkip: state.projectCreationData.chainLengthSkip,
}))
export class PendantChainLength extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      gender: "male"
    }
  }

  updateField(field, e){
    this.props.dispatch({
      type: "UPDATE_PROJECT_CREATION_FIELD",
      field: field,
      value: $(e.target).val()
    })
  }

  toggleGender(){
    this.setState({gender: this.state.gender === 'female' ? 'male' : 'female'})
  }

  render(){
    return (
      <form className={"frame-wrapper fade-in chain-length" + (this.props.chainLength && this.props.chainLength.length > 0 ? " size-" + this.props.chainLength.replace("in", "") : " size-15mm") + (this.state.gender ? " hand-" + this.state.gender : " hand-female")} onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Pendant Chain Length</h2>
            <p className="subheader-body">How long would you like your chain to be?.
            </p>
            <div className="ring-size-img-wrapper">
              <img className="background" src="//images.custommade.com/UqgBMQuwCSesOUVjZUB6uOrGPc0=/custommade-attachments/8d64818948d4cbc__8_chain_length_gray_silhouette_01.png" />
              {Object.keys(PENDANT_CHAIN_LENGTHS).map(chainLength => (
                <div key={chainLength} className="size-overlay-wrapper">
                  <img className={"size-overlay" + ((this.props.chainLength && (this.props.chainLength.replace(" in", "") === chainLength)) || !this.props.chainLength ? " active" : "")} src={PENDANT_CHAIN_LENGTHS[chainLength]} />
                </div>
              ))}
            </div>
            <div className="field">
              <Select onChange={this.updateField.bind(this, 'chainLength')} value={this.props.chainLength} disabled={this.props.chainLengthSkip} label="Choose chain length">
                <option value="14 in">14"</option>
                <option value="16 in">16"</option>
                <option value="18 in">18"</option>
                <option value="20 in">20"</option>
                <option value="22 in">22"</option>
                <option value="24 in">24"</option>
                <option value="30 in">30"</option>
                <option value="36 in">36"</option>
              </Select>
            </div>
            <NotSure field="chainLengthSkip" fieldsToWipe={['chainLength']} resetValue={""} checked={this.props.chainLengthSkip}>I'm not sure yet</NotSure>
          </div>
        </div>
        {((this.props.chainLength && this.props.chainLength.length > 0) || this.props.chainLengthSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}


const PENDANT_CHAIN_STYLES = [
  {
    'name': 'delicate',
    'title': "Delicate",
    'cards': [
      {
        name: "rope",
        img: "//images.custommade.com/F43RZ-EHZAxePJw61WxD8yWoOPk=/custommade-attachments/91f2898b4c0daf2__9_chain_styles_delicate_fe5c09eaa4553a7_742029_b_2.jpg",
        label: "Rope"
      },
      {
        name: "cable",
        img: "//images.custommade.com/P92Fdf1UckkCDM0X9GA_DdyEXuo=/custommade-attachments/28f13f436e7c20b__9_chain_styles_delicate_002bb86b5570fa3_743865_1.jpg",
        label: "Cable"
      }
    ],
  },
  {
    'name': 'medium',
    'title': "Medium",
    'cards': [
      {
        name: "rolo",
        img: "//images.custommade.com/_r0A3wuUEx5d3QO_bsHbCK4uGWs=/custommade-attachments/be7004a8260dabd__9_chain_styles_medium_9079e2dc90278b9_584079_f_3.png",
        label: "Rolo"
      },
      {
        name: "curb",
        img: "//images.custommade.com/xeTYKEDsrw6PVP0RcUMX5Vj5BBE=/custommade-attachments/80a89da7b926240__9_chain_styles_medium_6e6ed87990a936b_640104_2.png",
        label: "Curb"
      }
    ],
  },
  {
    'name': 'thick',
    'title': "Thick",
    'cards': [
      {
        name: "thick_cable",
        img: "//images.custommade.com/re1j1CvPwPY3cdl2rM23ljQB8OI=/custommade-attachments/6ece19d61f1a1ed__9_chain_styles_thick_322e011b5d70084_748090_2.jpg",
        label: "Thick Cable"
      },
      {
        name: "figaro",
        img: "//images.custommade.com/Y9HubW_y7BX_OEhj4cAbTdKcwG0=/custommade-attachments/5648081800f7955__9_chain_styles_thick_62078c6e89ccf2d_702738_2.jpg",
        label: "Figaro"
      }
    ],
  },
]


@connect(state => ({
  chainStyle: state.projectCreationData.chainStyle,
  chainStyleSkip: state.projectCreationData.chainStyleSkip,
}))
export class PendantChainStyles extends React.Component {

  isChecked(name){
    return this.props.chainStyle === name
  }

  toggleChecked(name, e){
    e.preventDefault()
    if (!this.props.chainStyleSkip){
      this.props.dispatch({
        type: "UPDATE_PROJECT_CREATION_FIELD",
        field: 'chainStyle',
        value: name
      })
    }
  }

  render(){
    return (
      <form className="frame-wrapper fade-in" onSubmit={nextFrame}>
        <div className="frame-contents-wrapper">
          <div className="frame">
            <h2><PreviousLink />Chain Styles</h2>
            <p className="subheader-body">Which style do you prefer?</p>
            {PENDANT_CHAIN_STYLES.map(chainStyleGroup => (
              <div className="card-group" key={chainStyleGroup.name}>
                <h4 className="section-sub-header">{chainStyleGroup.title}</h4>
                <div className="cards-wrapper">
                  {chainStyleGroup.cards.map(card => (
                    <CheckMarkCard
                      key={card.name}
                      className={"card-small " + (card.smallText ? "card-small-text" : "")}
                      name={card.name}
                      imgUrl={card.img}
                      label={card.label}
                      checked={this.isChecked(card.name)}
                      disabled={this.props.chainStyleSkip}
                      toggleChecked={this.toggleChecked.bind(this, card.name)}
                      />
                  ))}
                </div>
              </div>
            ))}
            <NotSure field="chainStyleSkip" fieldsToWipe={['chainStyle']} resetValue={[]} checked={this.props.chainStyleSkip}>I'm not sure yet</NotSure>
          </div>
        </div>
        {((this.props.chainStyle && this.props.chainStyle.length > 0) || this.props.chainStyleSkip) && (
          <div className="action-bar fade-in">
            <button className="btn btn-primary btn-sm">Next</button>
          </div>
        )}
      </form>
    )
  }
}

const PENDANT_NEXT_STEPS_CARDS = [
  {
    name: "price",
    description: "Our design experts will prepare some initial quotes for you to review as a starting point for your necklace.",
    label: "I’d like to discuss price first."
  },
  {
    name: "questions",
    description: "If you have other things you’d like to discuss before our team gets started, let us know - one of our consultants will get in touch.",
    label: "I have questions to ask or other details to share first."
  },
  {
    name: "looking_around",
    description: "Just looking around for now? We’ll hold onto your details and you can let us know when you’re ready to get started.",
    label: "I’m not ready for a consultation yet."
  }
]


@connect(state => ({
  nextSteps: state.projectCreationData.nextSteps
}))
export class PendantNextSteps extends React.Component {


  render(){
    return (
      <NextSteps cards={PENDANT_NEXT_STEPS_CARDS} subheader="We have all the information we need to get started! We can start by talking more about the design of your necklace, or we can get right to some price estimates - which would you like to do first?" {...this.props} />
    )
  }
}
